/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useState } from 'react'
import { Form, Button, Upload, Icon, Select, message, Input } from 'antd'
import { Content, FullHeightSizer } from 'core/screen-util'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'

import * as api from 'api/pgads'
import { ErrorContext } from 'context'

const { Option } = Select

const TYPES = ['ONS', 'MNS', 'CNS', 'RNP', 'HNP', 'BNP']

const FileUploadForm = ({ form, targetInfo }) => {
  const [selectedFileName, setSelectedFileName] = useState()

  const [processing, setProcessing] = useState(false)
  const { setError } = useContext(ErrorContext)

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields((err, values) => {
      if (!err) {
        setProcessing(true)
        api
          .processDataWithFileUpload(targetInfo)(values)
          .fork(
            err => {
              setProcessing(false)
              setError(err)
            },
            () => {
              setProcessing(false)
              message.success('file processed successfully')
            }
          )
      }
    })
  }

  const normalizeFile = e => {
    if (e == null) {
      return e
    }
    // if (Array.isArray(e)) {
    //     return e;
    // }
    const file = e.file
    if (file == null) {
      return e
    }
    setSelectedFileName(file.name)
    // this logic is here because server is not accepting file if type is not provided
    if (file.type == null || file.type === '') {
      const fileWithType = file.slice(0, file.size, 'text/plain')
      return fileWithType
    }
    return file
  }

  const { getFieldDecorator } = form
  return (
    <Form onSubmit={handleSubmit}>
      {/* <Form.Item>
        {getFieldDecorator('fileName', {
          rules: [{ required: true, message: 'Please provide file name!' }],
        })(<Input placeholder="File Name" />)}
      </Form.Item> */}
      <Form.Item>
        {getFieldDecorator('id1', {
          rules: [{ required: true, message: 'Please select file type!' }],
        })(
          <Select placeholder="Select Type" showSearch>
            {TYPES.map(type => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>

      {/* <Form.Item>
        {getFieldDecorator('fileDate', {
          rules: [{ required: true, message: 'Please provide file date!' }],
        })(<DatePicker format="MM/DD/YYYY" style={{ width: '100%' }} />)}
      </Form.Item> */}

      {/* <Form.Item>
        {getFieldDecorator('id2', {
          // rules: [{ required: true, message: 'Please provide file name!' }],
        })(<Input placeholder="Id2" />)}
      </Form.Item> */}
      <Form.Item label="File">
        {getFieldDecorator('file', {
          valuePropName: 'file',
          getValueFromEvent: normalizeFile,
          rules: [{ required: true, message: 'Please provide file!' }],
        })(
          <Upload.Dragger
            name="file"
            multiple={false}
            showUploadList={false}
            withCredentials
            beforeUpload={() => false}
          >
            <p className="ant-upload-drag-icon">
              <Icon type={selectedFileName ? 'file' : 'inbox'} />
            </p>
            <p className="ant-upload-text">
              {' '}
              {selectedFileName || 'Click or drag file to this area to upload'}
            </p>
          </Upload.Dragger>
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('apiKey', {
          rules: [{ required: true, message: 'Please provide API key!' }],
        })(<Input placeholder="File Server Client API key" />)}
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={processing}>
          Process
        </Button>
      </Form.Item>
    </Form>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

const WrappedNormalLoginForm = connect(mapStateToProps)(
  Form.create({ name: 'file_upload_form' })(FileUploadForm)
)

const SwitchBoardImport = ({ targetInfo }) => {
  const [apiKey, setApiKey] = useState()

  const [loading, setLoading] = useState(false)
  const { setError } = useContext(ErrorContext)

  const getApiKey = () => {
    setLoading(true)
    api
      .getFileServerClientKey(targetInfo)()
      .fork(
        err => {
          setError(err)
          setLoading(false)
        },
        data => {
          setApiKey(data.jwt)
          setLoading(false)
        }
      )
  }

  return (
    <FullHeightSizer heightOffset={150}>
      {({ height }) => (
        <Content
          css={{
            height: height - 20,
            paddingTop: '10px',
          }}
        >
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <div
              css={{
                minWidth: 400,
                borderRight: '1px solid lightgrey',
                padding: 30,
              }}
            >
              <div css={{ textAlign: 'center' }}>
                <h1>Get Client API key</h1>
              </div>
              <div>
                <Button type="primary" loading={loading} onClick={getApiKey}>
                  Generate
                </Button>
                <Input.TextArea
                  css={{ marginTop: 20 }}
                  value={apiKey}
                  rows={10}
                />
              </div>
            </div>
            <div css={{ minWidth: 400, padding: 30 }}>
              <div css={{ textAlign: 'center' }}>
                <h1>Process File Test</h1>
              </div>
              <WrappedNormalLoginForm />
            </div>
          </div>
        </Content>
      )}
    </FullHeightSizer>
  )
}

export default connect(mapStateToProps)(SwitchBoardImport)
